import { Button } from "../design/button";
import { Input } from "../design/input";
import { Text } from "../design/text";
import { EditableFile } from "../models/EditableFile";

interface Props {
  editableFile: EditableFile;
  onChangeFileName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: () => void;
}

const EditableFileListItem: React.FC<Props> = ({
  editableFile,
  onChangeFileName,
  onRemove,
}) => {
  const renderPreview = (file: EditableFile) => {
    const fileType = file.file.type;

    if (fileType.startsWith("image/")) {
      return (
        <img
          src={file.preview!}
          alt={file.name}
          className="object-cover w-32 h-32 rounded-md"
          style={{ objectFit: "cover" }}
        />
      );
    } else if (fileType === "application/pdf") {
      return (
        <embed
          src={file.preview!}
          type="application/pdf"
          className="w-32 h-32 border rounded-md"
        />
      );
    } else if (fileType.startsWith("text/")) {
      return (
        <iframe
          src={file.preview!}
          title={file.name}
          className="w-32 h-32 border rounded-md"
        />
      );
    } else {
      return (
        <div className="flex items-center justify-center w-32 rounded-md h-32border">
          No Preview
        </div>
      );
    }
  };

  return (
    <div className="flex items-start gap-4 p-3 border rounded-md bg-gray-50 dark:bg-gray-800">
      {/* File Preview */}
      {renderPreview(editableFile)}

      {/* File Details */}
      <div className="flex-1 space-y-2">
        <Input
          type="text"
          value={editableFile.name}
          onChange={onChangeFileName}
          className="w-full p-2 border border-gray-300 rounded-md"
        />
        <Text className="text-sm">
          {editableFile.file.type} -{" "}
          {(editableFile.file.size / 1024).toFixed(2)} KB
        </Text>
      </div>

      {/* Remove Button */}
      <Button plain onClick={onRemove}>
        Remove
      </Button>
    </div>
  );
};

export default EditableFileListItem;
